import type {FC} from 'react';
import type {SanityImage} from '@selvklart/sanity-next-image';
import clsx from 'clsx';

import {ImageFillClient} from 'components/image/client';
import type {HeadingSchema} from 'components/page-heading/schema';

interface Props {
	data: HeadingSchema;
}

export const TextHeading: FC<Props> = ({data: {image, title, tagline}}) => {
	return (
		<div className={clsx('relative', 'isolate', 'overflow-hidden', 'bg-stone-900', 'py-16')}>
			{image && image.asset && (
				<ImageFillClient
					className={clsx('opacity-20', '-z-10')}
					image={image as SanityImage}
					alt={title ?? ''}
				/>
			)}
			<div className={clsx('mx-auto', 'max-w-7xl', 'w-full', 'px-6', 'lg:px-8')}>
				<div className={clsx('mx-auto', 'max-w-2xl', 'lg:mx-0')}>
					<h1
						className={clsx(
							'text-4xl',
							'font-bold',
							'tracking-tight',
							'text-white',
							'sm:text-6xl',
						)}
					>
						{title}
					</h1>
					{tagline && (
						<p className={clsx('mt-6', 'text-lg', 'leading-8', 'text-gray-300')}>
							{tagline}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};
